/**
 * The default ARIA label for the WeekNumber element.
 */
export var labelWeekNumber = function (n) {
    return "Week n. ".concat(n);
};
//# sourceMappingURL=labelWeekNumber.js.map